export function initMetaPixel() {
  const w = window as any
  if (w.fbq) return

  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.defer = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  w.fbq('init', '793935510144655')
  w.fbq('track', 'PageView')
}

export function trackAddToCart() {
  const PIXEL_ID = '793935510144655'
  const w = window as any

  // Primary: use fbq if available
  try {
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'AddToCart', {
        content_name: 'El Envés del Metabolismo',
        content_type: 'product',
        value: 9997,
        currency: 'ARS',
      })
    }
  } catch (e) {
    // silently fail, fallback below will handle it
  }

  // Fallback: fire a tracking pixel via image request
  // This ensures the event is sent even if fbevents.js hasn't loaded
  try {
    const params = new URLSearchParams({
      id: PIXEL_ID,
      ev: 'AddToCart',
      dl: window.location.href,
      rl: document.referrer,
      if: 'false',
      ts: String(Date.now()),
      'cd[content_name]': 'El Envés del Metabolismo',
      'cd[content_type]': 'product',
      'cd[value]': '9997',
      'cd[currency]': 'ARS',
    })
    const img = new Image(1, 1)
    img.src = `https://www.facebook.com/tr?${params.toString()}`
  } catch (e) {
    // silently fail
  }
}
